const FRAME = "#f4f0e4";
const TRACK = "rgba(20, 19, 16, 0.65)";
const INK = "#e9e2d0";

export class Hud {
  readonly canvas: HTMLCanvasElement;
  private readonly ctx: CanvasRenderingContext2D;
  private scale = 1;

  constructor() {
    this.canvas = document.createElement("canvas");
    this.canvas.className = "hud";
    const ctx = this.canvas.getContext("2d");
    if (!ctx) throw new Error("hud: 2d context unavailable");
    this.ctx = ctx;
  }

  get width(): number {
    return this.canvas.width / this.scale;
  }

  get height(): number {
    return this.canvas.height / this.scale;
  }

  resize(cssWidth: number, cssHeight: number): void {
    this.scale = Math.min(3, Math.max(1, window.devicePixelRatio || 1));
    this.canvas.width = Math.max(1, Math.round(cssWidth * this.scale));
    this.canvas.height = Math.max(1, Math.round(cssHeight * this.scale));
    this.canvas.style.width = `${cssWidth}px`;
    this.canvas.style.height = `${cssHeight}px`;
    this.ctx.setTransform(this.scale, 0, 0, this.scale, 0, 0);
  }

  begin(): void {
    this.ctx.clearRect(0, 0, this.width, this.height);
  }

  fill(x: number, y: number, w: number, h: number, colour: string): void {
    this.ctx.fillStyle = colour;
    this.ctx.fillRect(x, y, w, h);
  }

  outline(x: number, y: number, w: number, h: number, colour: string, thickness = 1): void {
    this.ctx.fillStyle = colour;
    const left = Math.round(x * this.scale) / this.scale;
    const top = Math.round(y * this.scale) / this.scale;
    const right = Math.round((x + w) * this.scale) / this.scale - thickness;
    const bottom = Math.round((y + h) * this.scale) / this.scale - thickness;
    this.ctx.fillRect(left, top, right - left + thickness, thickness);
    this.ctx.fillRect(left, bottom, right - left + thickness, thickness);
    this.ctx.fillRect(left, top, thickness, bottom - top + thickness);
    this.ctx.fillRect(right, top, thickness, bottom - top + thickness);
  }
}

export interface BootView {
  resize(cssWidth: number, cssHeight: number): void;
  draw(progress: number): void;
}

export function createBoot(background: string): BootView {
  const hud = new Hud();
  document.body.appendChild(hud.canvas);
  hud.canvas.dataset.role = "boot";

  const draw = (progress: number): void => {
    const width = 224;
    const height = 10;
    const padding = 8;
    const x = Math.round((hud.width - width) / 2);
    const y = Math.round(hud.height / 2);

    hud.begin();
    hud.fill(0, 0, hud.width, hud.height, background);
    hud.outline(x - padding, y - padding, width + padding * 2, height + padding * 2, FRAME, 2);
    hud.fill(x, y, width, height, TRACK);
    hud.fill(x, y, width * progress, height, INK);
  };

  return {
    resize(cssWidth: number, cssHeight: number): void {
      hud.resize(cssWidth, cssHeight);
    },
    draw,
  };
}
